import { DeliveryMethod, LabelPrint } from "../constants";

const isCollectionRequest = (defaultLocale: string | undefined | null, deliveryMethod: string | null | undefined, labelPrint: string | null | undefined): boolean => {
  return (defaultLocale === 'lt' || defaultLocale === 'lv') && deliveryMethod === DeliveryMethod.DoorToDoor && labelPrint === LabelPrint.COURIER;
}

export default isCollectionRequest;